"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
var _hooks = require("../../../hooks");
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var useStyles = function useStyles(data, getValueText) {
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    fontFamily = _useContext.fontFamily,
    basicFontSize = _useContext.basicFontSize,
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var totalSum = data ? data.reduce(function (sum, item) {
    return sum + item.value;
  }, 0) : 0;
  var maxValueWidth = data && getValueText ? Math.max.apply(Math, _toConsumableArray(data.map(function (i) {
    return getValueText(i.value, i.legendText).length * 8;
  }))) : 0;
  var maxLegendWidth = data ? Math.max.apply(Math, _toConsumableArray(data.map(function (i) {
    return i.legendText.length * 8;
  }))) : 0;
  var ccColorScaleStyle = (0, _react.useMemo)(function () {
    var ccColorScale = (0, _css.css)({
      fontSize: basicFontSize,
      fontFamily: fontFamily
    });

    /* Line view mode */

    var ccLine = (0, _css.css)({
      height: pxToRem(8),
      width: '100%',
      borderRadius: pxToRem(6),
      background: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.main,
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      justifyContent: 'flex-start',
      alignItems: 'stretch'
    });
    var ccLinePart = function ccLinePart(value, color) {
      return (0, _css.css)({
        position: 'relative',
        flex: 'none',
        width: value > 0 && totalSum > 0 ? value * 100 / totalSum + '%' : '0%',
        transition: 'width 0.5s linear',
        background: color
      });
    };
    var ccLineTooltipItem = (0, _css.css)({
      display: 'grid',
      alignItems: 'center',
      justifyItems: 'start',
      alignContent: 'stretch',
      justifyContent: 'start',
      gridTemplateColumns: 'auto auto',
      columnGap: pxToRem(10),
      '&:not(:last-child)': {
        marginBottom: pxToRem(10)
      }
    });
    var ccLineTooltipItemScale = (0, _css.css)({
      width: pxToRem(16),
      height: pxToRem(5),
      borderRadius: pxToRem(6)
    });
    var ccLineTooltipItemValue = (0, _css.css)({
      color: '#575962'
    });

    /* Table view mode */

    var ccTableItem = (0, _css.css)({
      display: 'grid',
      alignItems: 'center',
      justifyItems: 'start',
      alignContent: 'stretch',
      justifyContent: 'space-between',
      gridTemplateColumns: "".concat(pxToRem(maxValueWidth), " 1fr ").concat(pxToRem(maxLegendWidth)),
      columnGap: pxToRem(10),
      '&:not(:last-child)': {
        marginBottom: pxToRem(10)
      }
    });
    var ccTableItemValue = (0, _css.css)({
      width: '100%',
      textAlign: 'center'
    });
    var ccTableItemScale = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      flexWrap: 'nowrap',
      alignItems: 'stretch',
      width: '100%',
      justifyContent: 'center'
    });
    var ccTableItemLegend = (0, _css.css)({});

    /* Legend view mode */

    var ccLegend = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      columnGap: pxToRem(16)
    });
    var ccLegendItem = (0, _css.css)({
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      alignItems: 'center',
      justifyContent: 'flex-start',
      columnGap: pxToRem(6),
      fontSize: pxToRem(14),
      div: {
        width: pxToRem(36),
        height: pxToRem(8),
        borderRadius: pxToRem(6)
      }
    });
    var ccLegendItemText = (0, _css.css)({
      color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic.dark
    });
    return {
      ccColorScale: ccColorScale,
      ccLine: ccLine,
      ccLinePart: ccLinePart,
      ccLineTooltipItem: ccLineTooltipItem,
      ccLineTooltipItemScale: ccLineTooltipItemScale,
      ccLineTooltipItemValue: ccLineTooltipItemValue,
      ccTableItem: ccTableItem,
      ccTableItemValue: ccTableItemValue,
      ccTableItemScale: ccTableItemScale,
      ccTableItemLegend: ccTableItemLegend,
      ccLegend: ccLegend,
      ccLegendItem: ccLegendItem,
      ccLegendItemText: ccLegendItemText
    };
  }, [totalSum, maxValueWidth, maxLegendWidth, fontFamily, basicFontSize, themeColors === null || themeColors === void 0 ? void 0 : themeColors.basic, pxToRem]);
  return {
    'cc-ColorScale': ccColorScaleStyle.ccColorScale,
    'cc-ColorScale__line': ccColorScaleStyle.ccLine,
    'cc-ColorScale__line__part': ccColorScaleStyle.ccLinePart,
    'cc-ColorScale__line-tooltip-item': ccColorScaleStyle.ccLineTooltipItem,
    'cc-ColorScale__line-tooltip-item__scale': ccColorScaleStyle.ccLineTooltipItemScale,
    'cc-ColorScale__line-tooltip-item__value': ccColorScaleStyle.ccLineTooltipItemValue,
    'cc-ColorScale__table-item': ccColorScaleStyle.ccTableItem,
    'cc-ColorScale__table-item__value': ccColorScaleStyle.ccTableItemValue,
    'cc-ColorScale__table-item__scale': ccColorScaleStyle.ccTableItemScale,
    'cc-ColorScale__table-item__legend': ccColorScaleStyle.ccTableItemLegend,
    'cc-ColorScale__legend': ccColorScaleStyle.ccLegend,
    'cc-ColorScale__legend-item': ccColorScaleStyle.ccLegendItem,
    'cc-ColorScale__legend-item-text': ccColorScaleStyle.ccLegendItemText
  };
};
exports.useStyles = useStyles;
var _default = useStyles;
exports.default = _default;